var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-page-not-found',{attrs:{"va-page-not-found-custom":""}},[_c('img',{staticClass:"va-page-not-found-custom__image mb-3",attrs:{"slot":"image","src":"https://i.imgur.com/wodIng5.png"},slot:"image"})])}
var staticRenderFns = []

export { render, staticRenderFns }